import React from "react";

import { fetchLang } from "./Utils";
import { configureInterpolation } from "../../containers/i18n";
import Loading from "./Loading";
import {I18nProvider} from "../../containers/i18n";
import { defaultLang } from '../common/Constants';

class LangProvider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      langAvailable: false,
      lang: "",
      i18n: {}
    }

    this.loadLang = this.loadLang.bind(this);
  }

  setLang = available => {
    this.setState({ langAvailable: available });
  };

  setLangFlag = flag => {
    if (this.state.lang !== flag)
      this.setState({ lang: flag}, () => {console.log("SET LANG FLAG :::", flag)});
  }

  componentDidMount() {
    console.log("LANG PROVIDER componentDidMount", defaultLang);
    this.loadLang(defaultLang);
  }

  componentDidUpdate(prevProps, prevState) {
    console.log("LANG PROVIDER componentDidUpdate", this.state.lang, prevState);
    if (this.state.lang !== prevState.lang) this.loadLang(this.state.lang);
  } 

  loadLang(langFlag) {
    console.log(">>> loadLang", langFlag);
    this.setLang(false);

    fetchLang(langFlag, lang => {
      window.langObj = lang;
      this.setState({
        langAvailable: true,
        i18n: lang,
        lang: langFlag
      });
    });
  }

  render() {
    console.log("this.state.langAvailable ?", this.state.langAvailable, this.state.lang);
    if (!this.state.langAvailable) return <Loading show />;

    return (
      <I18nProvider i18n={this.state.i18n} 
      lang={this.state.lang} 
      interpolate={configureInterpolation()} 
      setLangFlag={this.setLangFlag}>
        {this.props.children}
      </I18nProvider>
    );
  }
}

export default LangProvider;

